<template>
  <div id="lesson">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <Lesson :lesson="lesson" />
  </div>
</template>

<script>
import CoursesAPI from "@/api/apiCourses";
import Lesson from "@/components/Lesson.vue";

export default {
  name: "LessonPage",
  components: { Lesson },
  data() {
    return {
      lesson: {},
      breadcrumbs: [
        {
          text: "Lessons",
          disabled: false,
          to: { name: "lessons" }
        }
      ]
    };
  },
  props: {
    id: [String, Number]
  },
  async mounted() {
    try {
      this.lesson = await CoursesAPI.getLesson(this.id);
      this.breadcrumbs.push({ text: this.lesson.title, disabled: true });
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
<style>
/* Unscoped style, can be used within all components within a lesson page */
#lesson {
  max-width: 800px;
}
.auto-width {
  max-width: max-content;
}
</style>
